import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import Page from '@shell/Page'
import ConfigDebugModal from 'features/debug/ConfigDebugModal'
import Header from '@ui/elements/Header'
import { usePackageUpgrades } from '@order/hooks/usePackages'
import { sDefaultTemplate } from '@order/steps/templates/Default/styles'
import { getFirstValidTl } from 'utils/i18nUtils'

import PackagesItem from './PackagesItem'
import { DEFAULT_DEAL_TYPES } from '@ca/common/types'

export default function PackagesStep() {
  const { i18n } = useTranslation(['screens', 'configuration', 'deals-configuration'])
  const text = 'deals-configuration:packages.steps'
  const { upgrades, basePackage, activePackage, baseDeal } =
    usePackageUpgrades()

  const isTypeUpgrade = basePackage?.type !== activePackage?.type

  const fromPackage = isTypeUpgrade ? activePackage || basePackage : basePackage
  const count = upgrades.length + (fromPackage ? 1 : 0)

  const title = getFirstValidTl(i18n, [
    `${text}.${baseDeal?.code?.toLowerCase()}.header.title`,
    `${text}.${baseDeal?.type}.header.title`,
    `${text}.${DEFAULT_DEAL_TYPES[0]}.header.title`,
  ])

  const desc = getFirstValidTl(i18n, [
    `${text}.${baseDeal?.code?.toLowerCase()}.header.desc`,
    `${text}.${baseDeal?.type}.header.desc`,
    `${text}.${DEFAULT_DEAL_TYPES[0]}.header.desc`,
  ])

  return (
    <Page stage="configuration">
      <Header title={title} desc={desc} />
      <View className={sDefaultTemplate}>
        {fromPackage && (
          <PackagesItem
            count={count}
            basePackage={fromPackage ?? undefined}
            item={fromPackage}
          />
        )}
        {upgrades.map((upgrade) => (
          <PackagesItem
            count={count}
            key={upgrade.config.id}
            deal={upgrade.deal.id !== baseDeal?.id ? upgrade.deal : undefined}
            discounts={upgrade.deal.discounts}
            basePackage={fromPackage ?? undefined}
            item={upgrade.config}
          />
        ))}
      </View>
      <ConfigDebugModal />
    </Page>
  )
}
